var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOdontology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4 0 0 6 0 12C0 16.22 2 22 4 24C6 26 8 40 12 40C21.08 40 16 26 20 26C24 26 18.92 40 28 40C32 40 34 26 36 24C38 22 40 16.22 40 12C40 6 36 0 30 0C24 0 24 2 20 2C16 2 16 0 10 0ZM10 4C14 4 16 6 20 6C24 6 26 4 30 4C33.34 4 36 8 36 12C36 15.5 34.28 20.22 32.38 22.12C30.66 23.84 28.12 35.88 27 35.88C26.58 35.88 26 33.76 26 31.18C26 27.1 24.86 22 20 22C15.14 22 14 27.1 14 31.18C14 33.76 13.42 35.88 13 35.88C11.88 35.88 9.34 23.84 7.62 22.12C5.72 20.22 4 15.5 4 12C4 8 6.66 4 10 4Z",
    fill: "#222529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOdontology);
export default __webpack_public_path__ + "static/media/icon_odontology.7077fbb339acd66cf3cff50148b241c8.svg";
export { ForwardRef as ReactComponent };